var $518825a316391bc4$exports = {};
$518825a316391bc4$exports = {
    "collapse": `Ahenda`,
    "expand": `Laienda`
};


export {$518825a316391bc4$exports as default};
//# sourceMappingURL=et-EE.mjs.map
